// @core/api/endpoints/payment/list_payment_methods.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListPaymentMethodsResponse,
} from '../../../types/payment';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/payment';

/**
 * List payment methods for billing account
 * Returns a paginated list of payment methods. Supports filtering and sorting.
 */
export async function ListPaymentMethods(
  billingAccountId: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListPaymentMethodsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/billing-accounts/:billingAccountId/payment-methods`;
  requestPath = requestPath.replace(':billingAccountId', encodeURIComponent(billingAccountId));
  const requestOptions = options;
  return client.get<ListPaymentMethodsResponse>(requestPath, { ...requestOptions, params });
}
